module.exports = __webpack_public_path__ + "img/multi_image06.4037baeb.png";